export default __webpack_public_path__ + "static/media/ImagemRepresentanteLogin.21f5e978.png";